import { render } from "./CookiesNormalInput.vue?vue&type=template&id=536418e7&scoped=true&ts=true"
import script from "./CookiesNormalInput.vue?vue&type=script&lang=ts"
export * from "./CookiesNormalInput.vue?vue&type=script&lang=ts"

import "./CookiesNormalInput.vue?vue&type=style&index=0&id=536418e7&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-536418e7"]])

export default __exports__